module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-14.9eb590e2.png";